
export const selectLocationSuggestions = (state) => state.location.locationSuggestions

export const selectCitySuggestions = (state) => state.location.citySuggestions
